import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "selectedRole"]

  connect() {
    const defaultRole = this.selectedRoleTarget ? this.selectedRoleTarget.value : "student"
    const selectedTab = this.tabTargets.find(tab => tab.dataset.role === defaultRole)

    if (selectedTab) {
      this.setActiveTab(selectedTab)
    }
  }

  selectRole(event) {
    const selectedTab = event.currentTarget
    this.setActiveTab(selectedTab)

    if (this.hasSelectedRoleTarget) {
      this.selectedRoleTarget.value = selectedTab.dataset.role
    }
  }

  setActiveTab(tab) {
    this.tabTargets.forEach(tab => {
      tab.classList.remove("tg-primary-border", "tg-primary-text")
      tab.classList.add("border-transparent")
    })

    tab.classList.add("tg-primary-border", "tg-primary-text")
    tab.classList.remove("border-transparent")
  }
}